import { useEffect } from "react";
import type { FeaturedRead } from "../dataTypes";

interface ReadModalProps {
  read: FeaturedRead;
  onClose: () => void;
}

export default function ReadModal({ read, onClose }: ReadModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[60] flex items-end justify-center bg-foreground-950/50 p-0 sm:items-center sm:p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-background-50 shadow-xl sm:rounded-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          aria-label="关闭"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-foreground-700 ring-1 ring-background-200 hover:text-foreground-950 backdrop-blur cursor-pointer"
        >
          <i className="ri-close-line text-xl leading-none"></i>
        </button>

        <div className="shrink-0">
          <img
            src={read.image}
            alt={read.title}
            className="h-44 w-full object-cover object-top sm:h-56"
          />
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-6 md:px-9">
          <div className="flex items-center gap-3">
            <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              {read.tag}
            </span>
            <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-time-line text-sm leading-none"></i>
              约 {read.minutes} 分钟读完
            </span>
          </div>

          <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {read.title}
          </h3>
          <p className="mt-3 border-l-2 border-primary-500 pl-4 text-[15px] italic leading-7 text-foreground-500">
            {read.excerpt}
          </p>

          <div className="mt-6 space-y-4">
            {read.body.map((para, i) => (
              <p key={i} className="text-[15px] leading-7 text-foreground-700">
                {para}
              </p>
            ))}
          </div>

          <div className="mt-7 rounded-lg bg-background-100 px-4 py-3 text-xs leading-5 text-foreground-500">
            <i className="ri-shield-check-line mr-1 text-sm leading-none text-primary-600"></i>
            理性吃瓜提示：本文为科普内容，涉及具体人物与事件的表述请以官方通报与权威信源为准。
          </div>
        </div>
      </div>
    </div>
  );
}